import { Button } from "@mantine/core";
import { IconX } from "@tabler/icons-react";

/**
 * @param {import("@mantine/core").ButtonProps} props
 */
export default function CancelActionButton(props) {
	return (
		<Button variant="default" leftSection={<IconX />} {...props}>
			Cancelar
		</Button>
	);
}
